import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import setLanguage from 'translation';
class NationalDay extends Component {
    componentDidMount() {
        // this.startCall();
         const language = localStorage.getItem("lang") ;
           setLanguage(language);
           //alert(language);
       }

    render() {
       
            return (
                <div id="main">
                    <div className='private-container'>
                        <div className="row">
                            <div className="col-md-12">
                                <h2 data-i18n="virtual_head">
                                    خدمة الزيارة الافتراضية
                                    <span className="icon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-headset" viewBox="0 0 16 16">
                                            <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5z"></path>
                                        </svg>
                                    </span>

                                </h2>
                            </div>
                        </div>
                        <div className='row'>
                            
                        </div>
                        
                        <div className='row'>
                            <div className='col-md-12' style={{ textAlign: "right" }}>
                                <div className='paragraph' style={{ textAlign: "center" }} data-ia18n="national_day_message">
                                    <br></br>
                                    عملائنا الأعزاء 
                                    <br></br>
نهنئكم بيوم التأسيس للمملكة العربية السعودية، و نفيدكم أن الخدمة غير متوفرة حالياً 
<br></br>
 وسيستأنف العمل ابتداء من يوم الخميس الموافق 23-02-2023 م – الساعة 8:00  صباحاً 
 <br>
 </br>
 وللاستفادة من خدماتنا الالكترونية نسعد بزيارتكم لصفحة 
<a href="https://www.gosi.gov.sa/ar/Services" data-i18n="oragnization_message">الخدمات الإلكترونية للمؤسسة</a>

                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            )
        
    }
}

export default NationalDay;
